import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs';
import {LoginRepository} from '../repositories/login.repository';

@Injectable()
export class LoginService {

  constructor(private loginRepository: LoginRepository) { }

  public login(username: string, password: string): Observable<boolean> {
    return this.loginRepository.login(username, password);
  }

  public logout(): Observable<boolean> {
    return this.loginRepository.logout();
  }

  public resetPassword(username: string): Observable<boolean> {
    return this.loginRepository.resetPassword(username);
  }

  public changePassword(oldPassword: string, newPassword: string): Observable<boolean> {
    return this.loginRepository.changePassword(oldPassword, newPassword);
  }
}
